 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTMLCOVER from '@/components/xhtml/Cover'
 import XHTMLEBB from '@/components/xhtml/EBB'
 import XHTMLLOVE_1 from '@/components/xhtml/love_1'
 import XHTMLTITLE from '@/components/xhtml/Title'
 import XHTMLFM from '@/components/xhtml/fm'
 import XHTMLTOC from '@/components/xhtml/toc'
 import XHTMLCHAPTER1 from '@/components/xhtml/Chapter1'
 import XHTMLCHAPTER2 from '@/components/xhtml/Chapter2'
 import XHTMLCHAPTER3 from '@/components/xhtml/Chapter3'
 import XHTMLCHAPTER4 from '@/components/xhtml/Chapter4'
 import XHTMLCHAPTER5 from '@/components/xhtml/Chapter5'
 import XHTMLLOVE_2 from '@/components/xhtml/love_2'
 import XHTMLAUTHOR from '@/components/xhtml/Author'
 import XHTMLCOPYRIGHT from '@/components/xhtml/Copyright'
 import XHTMLAUBA from '@/components/xhtml/auba'
 import XHTMLORIMAD from '@/components/xhtml/ORIM-ad'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/Cover",
 			"name" : "xhtml/Cover",
 			"component" : XHTMLCOVER
 		},
 		{
 			"path" : "/xhtml/EBB",
 			"name" : "xhtml/EBB",
 			"component" : XHTMLEBB
 		},
 		{
 			"path" : "/xhtml/love_1",
 			"name" : "xhtml/love_1",
 			"component" : XHTMLLOVE_1
 		},
 		{
 			"path" : "/xhtml/Title",
 			"name" : "xhtml/Title",
 			"component" : XHTMLTITLE
 		},
 		{
 			"path" : "/xhtml/fm",
 			"name" : "xhtml/fm",
 			"component" : XHTMLFM
 		},
 		{
 			"path" : "/xhtml/toc",
 			"name" : "xhtml/toc",
 			"component" : XHTMLTOC
 		},
 		{
 			"path" : "/xhtml/Chapter1",
 			"name" : "xhtml/Chapter1",
 			"component" : XHTMLCHAPTER1
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js